import React, { useEffect, useRef } from "react";

function GraphHtmlRenderer({ html, idx }) {
    const containerRef = useRef(null);

    useEffect(() => {
        if (!html) return;
        // Extract the body content
        const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
        const bodyContent = bodyMatch ? bodyMatch[1] : html;

        // Set the innerHTML
        if (containerRef.current) {
            containerRef.current.innerHTML = bodyContent;

            // Find and execute all scripts
            const scripts = containerRef.current.querySelectorAll("script");
            scripts.forEach((oldScript) => {
                const newScript = document.createElement("script");
                // Copy attributes
                for (let attr of oldScript.attributes) {
                    newScript.setAttribute(attr.name, attr.value);
                }
                newScript.text = oldScript.text;
                oldScript.parentNode.replaceChild(newScript, oldScript);
            });
        }
    }, [html]);

    return (
        <div
            id={`graph-html-${idx}`}
            ref={containerRef}
            style={{ width: "100%", height: "100%" }}
        />
    );
}

export default GraphHtmlRenderer;